import React, {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import {toast} from 'react-toastify'
import {logout} from './redux/AuthCRUD'
import * as auth from './redux/AuthRedux'

export function Logout() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    useEffect(() => {
        async function logoutUser() {
            await logout()
            dispatch(auth.actions.logout())
            toast.success('Sucesso ao deslogar usuário!')
            navigate('/autenticacao/entrar')
        }
        logoutUser()
    }, [dispatch, navigate])

    return <></>
}
